import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const RECENT_VIEWED_PROFILES_COUNT = 20

const initialState = {
  searchKeyword: "",
  userSearchResults: null,
  recentVisitedProfiles: []
} as ExploreSlice

export const explore = createSlice({
  name: "explore",
  initialState: initialState,
  reducers: {
    updateSearchKeyword: (state, action: PayloadAction<string>) => {
      state.searchKeyword = action.payload
    },
    updateUserSearchResult: (state, action: PayloadAction<SearchUserResponseDto | null>) => {
      state.userSearchResults = structuredClone(action.payload)
    },
    addViewedProfileToHistory: (state, action: PayloadAction<UserDto>) => {
      const newUser = action.payload
      const existingProfileIndex = state.recentVisitedProfiles.findIndex((user) => user.id === newUser.id)
      if (existingProfileIndex !== -1) {
        state.recentVisitedProfiles.splice(existingProfileIndex, 1)
      }
      state.recentVisitedProfiles.unshift(structuredClone(action.payload))
      if (state.recentVisitedProfiles.length > RECENT_VIEWED_PROFILES_COUNT) {
        state.recentVisitedProfiles.pop()
      }
    },
    removeProfileFromHistory: (state, action: PayloadAction<string>) => {
      const handle = action.payload
      const existingProfileIndex = state.recentVisitedProfiles.findIndex((user) => user.handle === handle)
      if (existingProfileIndex !== -1) {
        state.recentVisitedProfiles.splice(existingProfileIndex, 1)
      }
    },
    resetExploreSlice: (state) => {
      state.searchKeyword = initialState.searchKeyword
      state.userSearchResults = initialState.userSearchResults
    }
  }
})

export const {
  updateSearchKeyword,
  updateUserSearchResult,
  addViewedProfileToHistory,
  removeProfileFromHistory,
  resetExploreSlice
} = explore.actions

export default explore.reducer
